<template>
  <b-card-code title="Modifier Banque">
    <b-card-text>
      <span>Veuillez modifier les coordonnées du Bnaque </span>
    </b-card-text>

    <!-- form -->
    <validation-observer
      v-if="bank"
      ref="simpleRules"
    >
      <b-form>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="Abbreviation"
              label-for="abbreviation"
            >
              <validation-provider
                #default="{ errors }"
                name="abbreviation"
                rules="required"
              >
                <b-form-input
                  v-model="bank.abbreviation"
                  :state="errors.length > 0 ? false : null"
                  placeholder="abbreviation"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group
              label="Label"
              label-for="label"
            >
              <validation-provider
                #default="{ errors }"
                name="label"
                rules="required"
              >
                <b-form-input
                  v-model="bank.label"
                  :state="errors.length > 0 ? false : null"
                  placeholder="label"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <b-button
              variant="primary"
              type="submit"
              class="mb-1 mb-sm-0 mr-0 mr-sm-1"
              @click.prevent="editBank"
            >
              Modifier
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card-code>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import BCardCode from '@core/components/b-card-code'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
/* import vSelect from 'vue-select' */
import {
  BFormInput,
  BFormGroup,
  BForm,
  BRow,
  BCol,
  BButton,
  BCardText /*  */,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  components: {
    BCardCode,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    /* BFormTextarea, */
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
    BButton,
  },
  data() {
    return {
      username: '',
      bank: {},
      required,
      states: ['Ouverte', 'Clôturée'],

    }
  },
  created() {
    this.getBanks()
  },
  methods: {
    async getBanks() {
      this.load = 'true'
      const { id } = this.$route.params
      const response = await axios.get(`/api/banks/detail/${id}`)
      this.bank = response.data
      this.load = 'false'
    },
    async editBank() {
      this.$refs.simpleRules.validate().then(async success => {
        const { id } = this.$route.params

        if (success) {
          try {
            await axios
              .put(
                `/api/banks/update/${id}/`,
                {
                  abbreviation: this.bank.abbreviation,
                  label: this.bank.label,
                },
              )
            this.$router.push('/bank')
            setTimeout(() => {
              this.showToast('success', 'top-center', ' banque Modifié avec succés')
            }, 1000)
          } catch (err) {
            setTimeout(() => {
              this.showToast('danger', 'top-center', err.toString())
            }, 1000)
          }
        }
      })
    },
    showToast(variant, position, text) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: 'Notification',
            icon: 'InfoIcon',
            text,
            variant,
          },
        },
        {
          position,
        },
      )
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
